import React from "react";
import { Link } from "react-router-dom";
import { resources } from "@/content/resources";
import { PageHero, CtaBand } from "@/components/NovaKit";

export default function Resources() {
  return (
    <div data-testid="resources-page">
      <PageHero eyebrow={resources.eyebrow} heading={resources.heading} highlight="setup, market entry, and workflow decisions" intro={resources.intro} index="07" />
      <section className="border-t hairline panel">
        <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-14 py-20 md:py-24">
          <div className="mono text-[11px] tracking-[0.25em] uppercase grad-text font-semibold mb-8">07.1 · Launch content</div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {resources.groups.map((g, i) => {
              const featured = g.kind === "featured";
              return (
                <Link to={`/resources/${g.slug}`} key={g.slug}
                  className={"card-hover rounded-[20px] p-8 md:p-10 relative overflow-hidden min-h-[260px] flex flex-col justify-between " +
                    (featured && i === 0
                      ? "grad-bg text-white border hairline"
                      : "grad-border grad-border-on bg-white")}
                  data-testid={`resource-card-${i}`}>
                  <div>
                    <div className="flex items-baseline justify-between mb-6">
                      <span className={"mono text-[11px] font-bold tracking-[0.22em] uppercase " + ((featured && i === 0) ? "text-white/90" : "grad-text")}>
                        {featured ? "Featured Insight" : "Reference"} · 0{i + 1}
                      </span>
                      <span className={"mono text-[10px] tracking-[0.18em] " + ((featured && i === 0) ? "text-white/70" : "text-[#0A0E1A]/50")}>
                        {featured ? "Article" : "Reference"}
                      </span>
                    </div>
                    <h3 className={"display text-2xl md:text-3xl font-bold mb-4 leading-tight " + ((featured && i === 0) ? "text-white" : "")}>{g.title}</h3>
                    <p className={"text-sm md:text-base leading-relaxed " + ((featured && i === 0) ? "text-white/85" : "text-[#0A0E1A]/70")}>{g.summary}</p>
                  </div>
                  <div className={"mt-8 mono text-[11px] uppercase tracking-[0.2em] font-semibold flex items-center gap-2 " + ((featured && i === 0) ? "text-white" : "text-[#4F46E5]")}>
                    Read {g.kind === "featured" ? "article" : "reference"} <span>→</span>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
      <CtaBand heading="Looking for something specific?" body="Tell us what you are exploring and we will point you to the most relevant resources or advisor." ctas={resources.ctas} />
    </div>
  );
}
